import { faBriefcase, faHouse } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import ReactSelect from "components/base/ReactSelect";
import { useEmpresas } from "providers/EmpresaProvider";

export default function EmpresaSelector() {
  const { isLoading, empresas, selectedIds, selectEmpresas } = useEmpresas();

  const options = empresas.map((e) => ({
    value: e.id,
    label: e.nomeFantasia,
    localDeTrabalho: e.localDeTrabalho,
    homologacao: e.homologacao,
  }));

  const selectedOptions = options.filter((opt) =>
    selectedIds.includes(opt.value)
  );
  const defaultValue = options.filter((opt) => opt.localDeTrabalho);

  const formatOptionLabel = (option: any) => {
    return (
      <div className="d-flex gap-1 align-items-center">
        {option.localDeTrabalho && <FontAwesomeIcon icon={faBriefcase} />}
        <span>{option.label}</span>
        {option.homologacao && (
          <span className="badge bg-warning-subtle text-warning border border-warning-subtle ms-1" style={{ fontSize: "0.65em" }}>
            HML
          </span>
        )}
      </div>
    );
  };

  return (
    <ReactSelect
      isMulti
      isDisabled={isLoading}
      isLoading={isLoading}
      isClearable={false}
      placeholder="Selecionar empresas"
      options={options}
      defaultValue={defaultValue}
      formatOptionLabel={formatOptionLabel}
      value={selectedOptions}
      onChange={(selected: any) => {
        // Garante que pelo menos uma empresa permaneça selecionada
        if (selected && selected.length > 0) {
          const selectedValues = selected.map((e: any) => e.value);
          selectEmpresas(selectedValues);
        } else {
          // Se tentar remover todas as opções, mantenha pelo menos uma selecionada
          // (manter a última seleção que estava ativa)
          if (selectedIds.length > 0) {
            selectEmpresas([selectedIds[0]]);
          }
          // Se não houver nenhuma selecionada ainda, selecione a empresa local
          else {
            const localEmpresa = empresas.find((e) => e.localDeTrabalho);
            if (localEmpresa) {
              selectEmpresas([localEmpresa.id]);
            }
          }
        }
      }}
    />
  );
}
